//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GalleriesMediaAutofillModalActionType } from '@galleries/actions/galleriesMediaAutofillModalActions';
import { MEDIA_AUTOFILL_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IGalleriesMediaAutofillModal } from '@galleries/models/galleriesStateModel';

const initialState: IGalleriesMediaAutofillModal = {
  isOpen: false,
  readyToShow: false,
  modalContent: '',
};

export default function GalleriesMediaAutofillModalReducer(
  state: IGalleriesMediaAutofillModal = initialState,
  action: GalleriesMediaAutofillModalActionType,
): IGalleriesMediaAutofillModal {
  switch (action.type) {
    case MEDIA_AUTOFILL_MODAL_ACTIONS.SET_READY_TO_SHOW_MEDIA_AUTOFILL_MODAL: {
      return {
        ...state,
        readyToShow: action.readyToShow,
      };
    }
    case MEDIA_AUTOFILL_MODAL_ACTIONS.OPEN_MEDIA_AUTOFILL_MODAL: {
      return {
        ...state,
        isOpen: true,
      };
    }
    case MEDIA_AUTOFILL_MODAL_ACTIONS.CLOSE_MEDIA_AUTOFILL_MODAL: {
      return {
        ...state,
        isOpen: false,
      };
    }
    case MEDIA_AUTOFILL_MODAL_ACTIONS.SET_MODAL_CONTENT: {
      return {
        ...state,
        modalContent: action.modalContent,
      };
    }
    default:
      return state;
  }
}
